module.exports = __webpack_public_path__ + "media/images/PrepWorks-Logo_Light-1a9d069a7a26be972a1a1a2beb63a79f.svg";